import React from 'react';
import styled from '@emotion/styled';
import { Helmet } from 'react-helmet';

import { mq } from '../../_style';

import imgMain from '../../assets/imgs/about/factory/img-main.jpg';
import imgMainSp from '../../assets/imgs/about/factory/sp/img-main.jpg';
import movie01 from '../../assets/imgs/about/factory/movie-01.mp4';
import movie02 from '../../assets/imgs/about/factory/movie-02.mp4';
import movie03 from '../../assets/imgs/about/factory/movie-03.mp4';

import AboutMain from '../../components/organisms/aboutDetail/aboutDetailMain';
import SectionLineup from '../../components/organisms/sectionLineup';
import ArticleWrap from '../../components/organisms/articleWrap';
import ArticleBody from '../../components/organisms/articleBody';
import InnerLinkGroup from '../../components/molecules/about/innerLinkGroup';
import ArticleHeader from '../../components/molecules/articleHeader';
import ArticleSection from '../../components/molecules/articleSection';
import TextBlock from '../../components/molecules/textBlock';
import TextBlockGrid from '../../components/molecules/textBlockGrid';
import ArticleImage from '../../components/atoms/articleImage';
import ArticleVideo from '../../components/atoms/articleVideo';
import ArticleHeading from '../../components/atoms/articleHeading';
import Text from '../../components/atoms/text';

const Container = styled.div`
`;
const ImgSub = styled.div`
  flex: 1 0 auto;
  ${mq.pc} {
    padding: 0 40px;
    width: 160px;
  }
  ${mq.sp} {
    width: 80px;
  }
`;

const ColumnDetail = (props) => {
  return(
    <Container>
      <Helmet
          title="ロングセラーの秘密に迫るモンダミン工場に潜入！ | モンダミン 公式サイト | アース製薬"
          meta={[
              { name: 'description', content: 'モンダミンがみなさまのお手元に届くまでの道のりを徹底検証！普段は入ることのできないモンダミン工場の内部に潜入取材し、こだわりの機械や製造工程をご紹介します。' },
              { name: 'keywords', content: 'モンダミン,もんだみん,mondahmin,モンダミン工場,工場見学,オーラルケア,アース製薬' }
          ]}
        >
        <body data-block-header="true" />
      </Helmet>
      <AboutMain bg={imgMain} bgSp={imgMainSp}></AboutMain>
      <ArticleWrap>
        <ArticleBody>
          <ArticleHeader sub={<>ロングセラーの秘密に迫る</>} title={<>モンダミン工場に潜入！</>}>
            モンダミンがみなさまのお手元に届くまでの道のりを徹底検証！<br />普段は入ることのできないモンダミン工場の内部に潜入取材し、<br />こだわりの機械や製造工程をご紹介します。
          </ArticleHeader>
          <ArticleSection heading={<>潜入スタート！</>}>
            <TextBlock>
              <ArticleImage filename={'about/factory/img-01.png'}></ArticleImage>
              <ArticleHeading>徹底した衛生管理</ArticleHeading>
              <Text>モンダミン工場では、全身のほこりを除去するエアーシャワーや、センサーによって手を触れずに洗浄・消毒ができる手洗いシステムを導入して衛生管理を行っています。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>1.液調合</>}>
            <TextBlock>
              <ArticleImage filename={'about/factory/img-02.jpg'}></ArticleImage>
              <ArticleHeading>タンクローリー約3台分の巨大タンクがそびえ立つ！</ArticleHeading>
              <TextBlockGrid qa="true">
                <div>
                  <Text>モンダミンの内容液を調合します。原料の種類によりタンクを分け、調合するタンクに移したときに均一に混ざるようにすることで効率よく製造。1日で約8万本のモンダミンを生産しています。<br />また原料に用いる精製水（純水）は、医療現場の注射液などに使われるレベルのものを使用。安定した味と品質を確保することに特に力を入れています。</Text>
                </div>
                <ImgSub><ArticleImage filename={'about/factory/img-sub-04.png'}></ArticleImage></ImgSub>
              </TextBlockGrid>
              <ArticleImage filename={'about/factory/img-03.png'}></ArticleImage>
              <ArticleHeading>品質を厳しくチェック！</ArticleHeading>
              <Text>できあがった内容液は品質保証部が安全性・味の面から、均一に混ざっているか毎回チェックします。長く使い続けていただくために開発当初からこだわっている香味、また安心して口に含んでいただける品質を保てるように厳しい検査を行っています。そして検査に合格した液だけが容器詰めの工程に移ることができます。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>2.容器洗浄・液充填・キャップ巻き締め</>}>
            <TextBlock>
              <ArticleVideo src={movie01}></ArticleVideo>
              <ArticleHeading>1分間に200本の高速充填！</ArticleHeading>
              <Text>容器を逆さにしてエアー洗浄を行った後、瞬時に液を充填します。作業スピードを重視したライン設計で、1分間に200本の充填が可能です。</Text>
              <ArticleVideo src={movie02}></ArticleVideo>
              <ArticleHeading>あらゆるサイズのボトルに対応！</ArticleHeading>
              <Text>あらかじめ機械によって選別されたキャップがグルグルと高速回転しながらボトルを巻き締めていきます。<br />この機械はボトルを支えるパーツを工夫することで、大きさなどが異なる約40種類のアイテムに対応可能です。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>3.検査</>}>
            <TextBlock>
              <ArticleImage filename={'about/factory/img-04.png'}></ArticleImage>
              <TextBlockGrid>
                <div>
                  <ArticleHeading>一つ一つ丁寧に、確実に</ArticleHeading>
                  <Text>金属探知、重量検査、目視検査の3ステップで製品に不備がないか、厳重に確認します。<br />金属が混入していないか、規程の重量を満たしているかを機械でチェックした後、ボトルの中に異物が入っていないか、ボトルに凹みやキズはないかを熟練したスタッフが目視で最終チェックします。</Text>
                </div>
                <ImgSub><ArticleImage filename={'about/factory/img-sub-01.png'}></ArticleImage></ImgSub>
              </TextBlockGrid>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>4.フィルム装着・シール貼付</>}>
            <TextBlock>
              <ArticleVideo src={movie03}></ArticleVideo>
              <ArticleHeading>最終仕上げ</ArticleHeading>
              <Text>260℃の熱風でフィルムを収縮装着します。フィルムの左右・上下の位置をカメラで自動検知し、正しく装着された製品だけが後工程に流れていきます。<br />そして最後にアテンションシールを貼り付けます。シールの位置もカメラでしっかりチェックします。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>5.箱詰め・発送</>}>
            <TextBlock>
              <ArticleImage filename={'about/factory/img-05.png'}></ArticleImage>
              <ArticleHeading>機械による箱詰め</ArticleHeading>
              <Text>箱詰めは機械での作業がメインです。作業性を重視し、梱包した箱はそのまま垂直コンベアで倉庫に運ばれます。</Text>
              <ArticleImage filename={'about/factory/img-06.png'}></ArticleImage>
              <ArticleHeading>自動倉庫で管理、その後全国へ発送</ArticleHeading>
              <Text>箱詰めされたものは高さ26ｍ（4階）まである自動倉庫に格納されます。アイテムや生産日によって分けられ、徹底した在庫管理を行っています。その後、日本全国へ配送され、みなさまの元へ届けられます。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>モンダミン工場で働くスタッフに<br className="pcOnly" />突撃インタビュー！</>}>
            <TextBlock>
              <ArticleHeading>Q.年間どれくらい生産してるの？</ArticleHeading>
              <Text>2017年に新設された工場では、日産能力がこれまでの約2倍（約8万本）に増加。年間で約2,300万本のモンダミンを生産しています。</Text>
              <ArticleHeading qa="true">Q.モンダミンを作る際のこだわりは？</ArticleHeading>
              <TextBlockGrid qa="true">
                <div>
                  <Text>安定した味と品質のモンダミンをお客様に提供できるよう、原料となる精製水（純水）は医療現場の注射液などに使われるレベルのものを使用することにこだわっています。<br />また、各段階での検査装置の充実化や、容器（ボトル・キャップ）の衛生面を徹底管理するといった異物混入対策に力を注ぎ、お客様に安心してお使いいただけるものづくりを目指しています。</Text>
                </div>
                <ImgSub><ArticleImage filename={'about/factory/img-sub-02.png'}></ArticleImage></ImgSub>
              </TextBlockGrid>
              <ArticleHeading qa='true' spOnly='true'>Q.日々の業務で心がけていることは？</ArticleHeading>
              <TextBlockGrid spqa='true' alignSp='right'>
                <ImgSub><ArticleImage filename={'about/factory/img-sub-03.png'}></ArticleImage></ImgSub>
                <div>
                  <ArticleHeading pcOnly='true'>Q.日々の業務で心がけていることは？</ArticleHeading>
                  <Text>日々発生する課題に対してスタッフ一丸となって取り組み改善していく不屈の姿勢とチームワークを大切にしています。<br />朝礼では作業ミスを防ぐために当日の作業内容の唱和を行ったり、終礼では当日の出来高や反省点をみんなで共有することでチームワークを高め、今後の作業に活かしていけるように心がけています。</Text>
                </div>
              </TextBlockGrid>
            </TextBlock>
          </ArticleSection>
        </ArticleBody>
        <InnerLinkGroup path={props.path}></InnerLinkGroup>
      </ArticleWrap>
      <SectionLineup></SectionLineup>
    </Container>
  );
};
export default ColumnDetail;
